import { render } from "./indexfivepricing.vue?vue&type=template&id=5378912c"
import script from "./indexfivepricing.vue?vue&type=script&lang=js"
export * from "./indexfivepricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__